import { HTags } from "@shared/src/datatypes/HTags";
import { ValueControlDataTypes } from "@shared/src/enums/ValueControlDataTypes";
import { HColor, HDate, HHour, HHourInterval, HHourIntervals, HTime } from "@shared/src/public-api";

export class ValueControlCtrl {
      
    public name: string; 
    public type: string; 
    public enumValues: any; 
    public enumTranslateGroup: string; 
    public caption: string; 
    public helpResource : string; 
    public showHelpPoint: boolean; 

    public value:any;

    public static build(name: string, type: string, enumValues: any, enumTranslateGroup: string, caption: string, helpResource : string, showHelpPoint: boolean): ValueControlCtrl{
        let r = new ValueControlCtrl();
        r.name = name;
        r.type = type;
        r.enumValues = enumValues;
        r.enumTranslateGroup = enumTranslateGroup;
        r.caption = caption;
        r.helpResource  = helpResource ;
        r.showHelpPoint = showHelpPoint;
        return r;
    }

    public static buildAndLoadValue(name: string, type: string, enumValues: any, enumTranslateGroup: string, caption: string, helpResource : string, showHelpPoint: boolean, value: any): ValueControlCtrl{
        let result = ValueControlCtrl.build(name, type, enumValues, enumTranslateGroup, caption, helpResource, showHelpPoint);
        result.loadValue(value);
        return result;
    }

    public loadValue(value: any){

        if (this.type == ValueControlDataTypes.Boolean)
          this.value = value == "true" ? true : false;
        else if (this.type == ValueControlDataTypes.HTriState)
          this.value.state = value == "1" ? 1 : value == "0" ? 0 : -1;
        else if (this.type == ValueControlDataTypes.HDate)
          this.value = HDate.fromStringDate(value);
        else if (this.type == ValueControlDataTypes.HTags)
          this.value = HTags.convertToHTags(value);
        else if (this.type == ValueControlDataTypes.HTime)
          this.value = HTime.build(value);
        else if (this.type == ValueControlDataTypes.HHour)
          this.value = HHour.build(value);
        else if (this.type == ValueControlDataTypes.Long || this.type == ValueControlDataTypes.Integer || this.type == ValueControlDataTypes.Double)
          this.value = +value;
        else if (this.type == ValueControlDataTypes.Enum)
          this.value = value;
        else if (this.type == ValueControlDataTypes.HHourInterval)
          this.value = HHourInterval.buildstr(value);
        else if (this.type == ValueControlDataTypes.HHourIntervals)
          this.value = HHourIntervals.buildstr(value);
        else if (this.type == ValueControlDataTypes.Color)
          this.value = HColor.build(value);
        else
          this.value = value;
    }


    public getValueString(): string {
      if (this.value != null) {
        if (this.type == ValueControlDataTypes.Boolean)
          return  this.value == true ? "true" : "false";
        else if (this.type == ValueControlDataTypes.Long || this.type == ValueControlDataTypes.Integer || this.type == ValueControlDataTypes.Double)
          return  this.value.toString();
        else if (this.type == ValueControlDataTypes.HDate)
          return  HDate.getDateString(this.value);
        else if (this.type == ValueControlDataTypes.HTags)
          return  HTags.convertToString(this.value);
        else if (this.type == ValueControlDataTypes.HTime)
          return  HTime.getTimeString(this.value);
        else if (this.type == ValueControlDataTypes.HHour)
          return  HHour.getHourString(this.value);
        else if (this.type == ValueControlDataTypes.HHourInterval)
          return  HHourInterval.toHourIntervalString(this.value);
        else if (this.type == ValueControlDataTypes.HHourIntervals)
          return  HHourIntervals.toHourIntervalsString(this.value);
        else
          return  this.value;
      } else
        return  "";
    }
}